export const PROGRESS_OPTIONS = [
  { value: "0% Complete", label: "Not started (0%)" },
  { value: "less than 50% Complete", label: "Under 50% complete" },
  { value: "more than 50% Complete", label: "50% to under 100%" },
  { value: "100% Complete", label: "100% complete" },
];

export const getProjectProgress = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const progress = parseFloat(value);
  return Number.isFinite(progress) ? Math.min(100, Math.max(0, progress)) : null;
};

export const isProgressInRange = (value, filter) => {
  const progress = getProjectProgress(value);
  if (progress === null) return false;
  switch (filter) {
    case "0% Complete":
      return progress === 0;
    case "less than 50% Complete":
      return progress > 0 && progress < 50;
    case "more than 50% Complete":
      return progress >= 50 && progress < 100;
    case "100% Complete":
      return progress === 100;
    default:
      return false;
  }
};

export const getFilterOptions = (projects, field) =>
  [...new Set(
    projects
      .map((project) => project[field])
      .filter((value) => value !== null && value !== undefined && value !== ""),
  )]
    .sort((a, b) => String(a).localeCompare(String(b)))
    .map((value) => ({ value, label: String(value) }));

export const filterProjects = (
  projects,
  { search = "", progressFilter, typeFilter, statusFilter } = {},
) => {
  const query = search.trim().toLowerCase();
  return projects.filter((project) => {
    if (progressFilter && !isProgressInRange(project.Progress, progressFilter)) return false;
    if (typeFilter && project.Type !== typeFilter) return false;
    if (statusFilter && project.RegistrationStatus !== statusFilter) return false;
    if (!query) return true;
    const number = String(project["Project Number"] ?? "").toLowerCase();
    return (
      String(project["Project Name"] ?? "").toLowerCase().includes(query) ||
      String(project.Type ?? "").toLowerCase().includes(query) ||
      number.includes(query) ||
      number.replace(/\s/g, "").includes(query.replace(/\s/g, ""))
    );
  });
};
